import { createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "d-flex gap-1"
};
const _hoisted_2 = { class: "d-flex" };
const _hoisted_3 = { class: "filter-button-value truncate max-w-[min(90vw,500px)]" };
const _hoisted_4 = {
    key: 1,
    class: "filter-button-value truncate max-w-[min(90vw,500px)]"
};
const _hoisted_5 = { class: "combined-filter-content" };
const _hoisted_6 = {
    key: 0,
    class: "combined-filter-type no-padding en-filter-type"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["EnFilterButtonBase"], {
        modelValue: $setup.menuIsVisible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.menuIsVisible) = $event)),
        "apply-button-text": $setup.applyButtonTextComputed,
        "reset-button-text": $setup.resetButtonTextComputed,
        "apply-filters": $setup.applyFilters,
        "on-reset-button-clicked": $setup.onResetButtonClicked,
        "display-string": $setup.displayString,
        "reset-filter": $setup.resetFilter,
        label: $props.hideMenuTitle ? null : $props.label,
        id: $setup.returnFilterButtonId($props.id),
        "search-input-class": "compact-top-padding bg-transparent"
    }, {
        label: _withCtx(() => [
            _createCommentVNode(" @slot The filter button's label. "),
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]),
        "display-string": _withCtx(() => [
            ($setup.anyValueIsSet)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.fieldKeys, (fieldKey, index) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            (_openBlock(), _createBlock($setup["EnFilterButtonTypePrefix"], {
                                "should-show-prefix": $setup.shouldShowPrefixMethod($setup.changedValue[fieldKey].filterType),
                                type: $setup.changedValue[fieldKey].filterType,
                                key: index
                            }, null, 8 /* PROPS */, ["should-show-prefix", "type"])),
                            _createElementVNode("b", _hoisted_3, _toDisplayString($setup.getDisplayValue($setup.changedValue[fieldKey])), 1 /* TEXT */)
                        ]));
                    }), 256 /* UNKEYED_FRAGMENT */))
                ]))
                : (_openBlock(), _createElementBlock("b", _hoisted_4, _toDisplayString($setup.displayString), 1 /* TEXT */))
        ]),
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.fieldKeys, (fieldKey, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "combined-filter-row"
                    }, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["no-padding", {
                                    'combined-filter-value': $setup.shouldShowFilterTypeSelection(fieldKey),
                                    'combined-filter-value-full': $setup.changedValue[fieldKey].filterButtonType === $setup.FilterButtonType.Autocomplete,
                                }])
                        }, [
                            ($setup.changedValue[fieldKey].filterButtonType === $setup.FilterButtonType.Date)
                                ? (_openBlock(), _createBlock($setup["EnDatePicker"], {
                                    key: 0,
                                    class: _normalizeClass({ 'value-input': $setup.shouldShowFilterTypeSelection(fieldKey) }),
                                    "model-value": $setup.changedValue[fieldKey].value,
                                    hint: $setup.changedValue[fieldKey].label,
                                    id: $setup.returnId($setup.getInputId(fieldKey)),
                                    "allowed-dates": $setup.changedValue[fieldKey].allowedDates,
                                    "onUpdate:modelValue": ($event) => ($setup.updateFieldValue(fieldKey, $event)),
                                    "persistent-hint": "",
                                    "show-month-year-dropdowns": ""
                                }, null, 8 /* PROPS */, ["class", "model-value", "hint", "id", "allowed-dates", "onUpdate:modelValue"]))
                                : _createCommentVNode("v-if", true),
                            ($setup.changedValue[fieldKey].filterButtonType === $setup.FilterButtonType.Input || $setup.changedValue[fieldKey].filterButtonType === $setup.FilterButtonType.Number)
                                ? (_openBlock(), _createBlock($setup["EnTextField"], {
                                    key: 1,
                                    class: _normalizeClass(["en-text-field w-full", { 'col no-margin no-padding value-input': $setup.shouldShowFilterTypeSelection(fieldKey) }]),
                                    "model-value": $setup.changedValue[fieldKey].value,
                                    hint: $setup.changedValue[fieldKey].label,
                                    id: $setup.returnId($setup.getInputId(fieldKey)),
                                    "onUpdate:modelValue": ($event) => ($setup.updateFieldValue(fieldKey, $event)),
                                    onKeydown: _withKeys($setup.applyFilters, ["enter"]),
                                    "persistent-hint": ""
                                }, null, 8 /* PROPS */, ["model-value", "class", "hint", "id", "onUpdate:modelValue", "onKeydown"]))
                                : _createCommentVNode("v-if", true),
                            ($setup.changedValue[fieldKey].filterButtonType === $setup.FilterButtonType.Autocomplete)
                                ? (_openBlock(), _createBlock($setup["EnAutocomplete"], {
                                    key: 2,
                                    class: _normalizeClass(["en-text-field combined-filter-autocomplete", { 'col no-margin no-padding value-input': $setup.shouldShowFilterTypeSelection(fieldKey) }]),
                                    modelValue: $setup.changedValue[fieldKey].value,
                                    "onUpdate:modelValue": [($event) => (($setup.changedValue[fieldKey].value) = $event), $setup.applyAutocompleteFilterSelection],
                                    hint: $setup.changedValue[fieldKey].label,
                                    id: $setup.returnId($setup.getInputId(fieldKey)),
                                    "api-uri": $setup.changedValue[fieldKey].apiUrl,
                                    items: $setup.changedValue[fieldKey].items,
                                    "preselected-object": $setup.getAutocompletePreselectedObject(fieldKey),
                                    "item-value": $setup.changedValue[fieldKey].itemValue ?? $setup.changedValue[fieldKey].dataField,
                                    "display-expression": $setup.changedValue[fieldKey].displayExpression ?? $setup.changedValue[fieldKey].dataField,
                                    "search-expression": $setup.changedValue[fieldKey].searchExpression ?? $setup.changedValue[fieldKey].dataField,
                                    "search-value": $setup.changedValue[fieldKey].searchValue,
                                    "select-expression": $setup.changedValue[fieldKey].selectExpression ?? [$setup.changedValue[fieldKey].dataField],
                                    group: $setup.changedValue[fieldKey].group,
                                    "hide-null-values": $setup.changedValue[fieldKey].hideNullValues,
                                    "use-contains": $setup.changedValue[fieldKey].useContains,
                                    "items-per-page": $setup.changedValue[fieldKey].itemsPerPage,
                                    "persistent-hint": "",
                                    clearable: "",
                                    onEnterPressed: $setup.applyFilters
                                }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "class", "hint", "id", "api-uri", "items", "preselected-object", "item-value", "display-expression", "search-expression", "search-value", "select-expression", "group", "hide-null-values", "use-contains", "items-per-page", "onEnterPressed"]))
                                : _createCommentVNode("v-if", true)
                        ], 2 /* CLASS */),
                        ($setup.shouldShowFilterTypeSelection(fieldKey))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createVNode($setup["EnFilterTypeSelectButton"], {
                                    modelValue: $setup.changedValue[fieldKey].filterType,
                                    "onUpdate:modelValue": ($event) => (($setup.changedValue[fieldKey].filterType) = $event),
                                    class: _normalizeClass({ 'date-filter-type-select': $setup.changedValue[fieldKey].filterButtonType === $setup.FilterButtonType.Date }),
                                    items: $setup.actualTypeItems($setup.changedValue[fieldKey]),
                                    id: $setup.returnTypeId(fieldKey)
                                }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "class", "items", "id"])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]));
                }), 128 /* KEYED_FRAGMENT */))
            ])
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["modelValue", "apply-button-text", "reset-button-text", "apply-filters", "on-reset-button-clicked", "display-string", "reset-filter", "label", "id"]));
}
